import { LocalTypes } from '../types/Recruitomat';
import { merge } from 'lodash';
import Loader, { loadWrap } from './mixins/Loader';
import ApiService from '@jobstairs/axios-api-service';
import { isEmpty } from 'lodash';
import tokenService from '@/services/TokenService';

export default function ({ baseURL, endpoints }) {
    const apiService = new ApiService({ baseURL: baseURL });

    return merge(Loader(), {
        state: {
            predictions: {},
        },
        getters: {},
        actions: {
            async [LocalTypes.actions.LOAD_PREDICTIONS]({ commit }, id) {
                await loadWrap(commit, async () => {
                    const headers =
                        tokenService.getAuthenticationHeader()['headers'];
                    const response = await apiService.get({
                        endpoint: `${endpoints.analysis}/${id}`,
                        headers,
                    });
                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    let recruitomatPredictions = response.data;
                    commit(
                        LocalTypes.mutations.SET_PREDICTIONS,
                        recruitomatPredictions,
                    );
                });
            },
            async [LocalTypes.actions.LOAD_CUSTOM_PREDICTIONS](
                { commit },
                data,
            ) {
                await loadWrap(commit, async () => {
                    const headers =
                        tokenService.getAuthenticationHeader()['headers'];
                    const response = await apiService.post({
                        endpoint: endpoints.analysis,
                        data: {
                            text: data.fulltext,
                            title: data.title,
                        },
                        headers,
                    });
                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    // fill Actual so Recruitomat Items will be displayed properly
                    response.data.Actual = {};
                    response.data.Prediction = {};
                    let recruitomatPredictions = response.data;
                    commit(
                        LocalTypes.mutations.SET_PREDICTIONS,
                        recruitomatPredictions,
                    );
                });
            },
        },
        mutations: {
            [LocalTypes.mutations.SET_PREDICTIONS]: (
                state,
                recruitomatPredictions,
            ) => {
                state.predictions = recruitomatPredictions;
            },
        },
    });
}
